<div #bannerContainer id="banner">
  @if (shouldDisplayBanner) {
    <div class="banner-message-container">
      <div [style.background-color]="bannerBackgroundColor" [style.color]="bannerForegroundColor"
       [style.font-size]="bannerFontSize" class="banner-message">
        @if (!!config?.link) {
        <a id="banner-link" class="link" [href]="config.link" target="_blank">
          {{ config.message | translate:locale.language }}
          <button mat-icon-button aria-labelledby="banner-link">
            <mat-icon>launch</mat-icon>
          </button>
        </a>
        } @else {
        {{ config?.message | translate:locale.language }}
        }
      </div>
    </div>
  }
</div>